var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97727 18L3.38636 14.4667V9.13333L0 7.33333L9.97727 2L20 7.33333V14.3778H18.6364V8.11111L16.5682 9.13333V14.4667L9.97727 18ZM9.97727 11.1556L17.1364 7.33333L9.97727 3.57778L2.86364 7.33333L9.97727 11.1556ZM9.97727 16.4889L15.2045 13.6667V9.93333L9.97727 12.6667L4.75 9.88889V13.6667L9.97727 16.4889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.35c5e5e421085ef14b21ab7aadb22c1c.svg";
export { ForwardRef as ReactComponent };